export const COMPANY_HISTORY_ITEMS = [
  {
    id: '2015',
    date: '2015',
    caption:
      'StartupCraft was born from a shared vision: to help startups build software that actually ships.',
  },
  {
    id: '2016',
    date: '2016',
    caption: 'Adopted a fully remote model before it became the norm.',
  },
  {
    id: '2017',
    date: '2017',
    caption:
      'From freelancers to a full-stack product agency with dedicated delivery pipelines.',
  },
  {
    id: '2019',
    date: '2019',
    caption: 'Expanded delivery across EU, US and APAC time zones.',
  },
  {
    id: '2020',
    date: '2020',
    caption:
      'Launched our flagship internal product: Worklair - a platform to manage teams, budgets, and delivery in one place.',
  },
  {
    id: '2022',
    date: '2022',
    caption:
      'Helped scale companies in AI, healthcare, fintech and supply chain, pushing tech boundaries in regulated environments.',
  },
  {
    id: '2024–2026',
    date: '2024–2026',
    caption:
      'Operational platforms for construction, automotive, healthcare and workforce-heavy businesses — and increasingly the AI running inside them.',
  },
]
